<template>
    <div class="container-fluid mt-5">
        <div class="row">
            <div class="col-md-12 text-center">
                <h3>Total de Pacientes</h3>
                <p class="text-muted">Esta es la cantidad de todos los pacientes registrados bajo tu cuidado.</p>
            </div>
            <div class="col-md-12 text-center">
                <div v-if="isLoading">
                    <vs-spinner color="rgb(255,159,64)" />
                </div>
                <div v-else>
                    <apexchart type="radialBar" :options="chartOptions" :series="[100]" height="250" />
                    <div class="total-pacientes-number">{{ totalPacientes }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import axios from "axios";
var config = require("@/config/api.json");
const API = config.api;

export default {
    name: "TotalPacientes",
    components: {
        apexchart: VueApexCharts
    },
    props: {
        personal_medico_id: {
            type: [String, Number],
            required: true
        }
    },
    data() {
        return {
            isLoading: true,
            totalPacientes: 0,
            chartOptions: {
                chart: {
                    type: "radialBar"
                },
                plotOptions: {
                    radialBar: {
                        hollow: {
                            size: "70%"
                        },
                        dataLabels: {
                            show: false // Ocultar las etiquetas del gráfico
                        }
                    }
                },
                colors: ["#ff9f40"] // Cambiar el color del círculo
            }
        };
    },
    mounted() {
        this.fetchTotalPacientes();
    },
    methods: {
        async fetchTotalPacientes() {
            try {
                const response = await axios.get(`${API}/total_pacientes`, {
                    params: {
                        personal_medico_id: this.personal_medico_id
                    }
                });

                if (response.data.status === "success") {
                    this.totalPacientes = response.data.data.total_pacientes;
                } else {
                    this.notify("error", "No se pudo obtener el total de pacientes.");
                }
            } catch (error) {
                console.error(error);
                this.notify("error", `Error: ${error.response?.data?.message || error.message}`);
            } finally {
                this.isLoading = false;
            }
        }
    }
};
</script>

<style scoped>
.text-main-gradient {
    background: linear-gradient(to right, #ff9f40, #ffcd56);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.total-pacientes-number {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 36px;
    font-weight: bold;
    color: #ff9f40; /* Cambiar el color del número */
}
</style>
